import * as request from "request";

export function getRequestExternal(url: string, apiBody: object) {
    return new Promise((resolve, reject) => {
        request({
            url,
            method: "GET",
        }, (err, httpReq, body) => {
            if (err || httpReq.statusCode !== 200) { reject({err, status: httpReq.statusCode}); }
            if (httpReq.statusCode === 200) { resolve(body); }
        });
    });
}
